import {
  USER_SAVE,
  USER_LOGIN,
  USER_LOGOUT,
  USER_NAME_SAVE,
  USER_VIDEO_TUTORIAL,
  USER_CONECTION,
  USER_BRANCH_SAVE
} from "./mutation-types";

export default {
  [USER_SAVE](state, data) {
    state.data = data.user;
    state.userAccess = data.access;
  },
  [USER_LOGIN](state) {
    state.loggedIn = true;
    state.showTutorialVideo = true;
  },
  [USER_VIDEO_TUTORIAL](state, status) {
    state.showTutorialVideo = status;
  },
  [USER_NAME_SAVE](state, name) {
    state.userName = name;
  },
  [USER_BRANCH_SAVE](state, branch) {
    state.userBranch = branch;
  },
  [USER_LOGOUT](state) {
    state.data = {};
    state.loggedIn = false;
    state.userName = "";
  },
  [USER_CONECTION](state, status) {
    state.userOnline = status;
  }
};
